<template>
    <div class="homepage-header">
        <user-info></user-info>
        <md-row :gutter="16" class='homepage-bottom'>
            <md-col :span="24" class="homepage-left">
                <!-- 我的待办 -->
                <my-agent class="my-agent"/>
                <!--通知公告-->
                <notice class="notice"></notice>
            </md-col>
        </md-row>
    </div>
</template>
<script>
import axios from 'axios';
import userInfo from './components/userInfo.vue';
import myAgent from './components/my-agent.vue';
import notice from './components/notice.vue';

export default {
    components: {
        userInfo,
        myAgent,
        notice,
    },
    methods: {
        /* 获取供应商信息 */
        getCurrentVendor() {
            axios.post('/gscint/vendor/getCurrentVendor')
                .then((res) => {
                    const { data = {} } = res.data;
                    localStorage.setItem('supplierInfo', JSON.stringify(data));
                    this.$store.commit('updateSupplierInfo', data);
                });
        },
    },
    mounted() {
        this.getCurrentVendor();
    },
};
</script>
<style lang="less" scoped>
@block-margin: 16px;
@min-width: 1024px;
.box {
    background: #FFFFFF;
    box-shadow: 0px 1px 4px 0px rgba(0,21,41,0.06);
    border-radius: 4px;
    margin-bottom: @block-margin;
}
.homepage-header {
    min-width: @min-width;
    height: 132px;
    border-radius: 4px;
}
.homepage-bottom {
    margin-top: @block-margin;
    min-width: 1039px;
    .homepage-left {
        display: flex;
        flex-direction: column;
        height: 569px;
        .my-agent {
            max-height: 228px;
            .box
        }
        .notice {
            height: 308px;
            flex: 1;
            .box
        }
    }
}
</style>
